import React, { useEffect, useState } from "react";


import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";

import "./style.css";

import Header from "../../Components/Header";
import ProfileDisplay from "../../Components/ProfileDisplay";
import { useUpdateUserMutation } from "../../Redux/Apis/User";
import { useGetWithdrawlsQuery, useUpdateWithdrawlMutation } from "../../Redux/Apis/Withdrawl";
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";

const sortValues = [
  {
    text: "Name",
    value: "fullName",
  },
  {
    text: "Email",
    value: "email",
  }
];

const perPageValues = [
  {
    text: "8",
    value: 8,
  },
  {
    text: "15",
    value: 15,
  },
  {
    text: "30",
    value: 30,
  }
];


const maleHeaders = [
  {
    key: "id",
    title: "Id No",
  },
  {
    key: "profile_name",
    title: "Profile Name",
  },
  {
    key: "iban",
    title: "IBAN Number",
  },
  {
    key: "bank_name",
    title: "Bank Name",
  },
  {
    key: "name_account",
    title: "Name on Account",
  },
  {
    key: "amount",
    title: "Amount",
  },
  {
    key: "reciept_no",
    title: "Receipt No",
  },
  {
    key: "actions",
    title: "",
  },
];

const WithdrawlRequests = () => {


  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
  const [selectedId, setSelectedId] = useState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [sortBy, setSortBy] = useState(sortValues[0].value);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [filters, setFilters] = useState()
  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isLoading, refetch, isFetching } = useGetWithdrawlsQuery({
    page,
    rowsPerPage: perPage,
    search: debouncedSearch,
    sortBy,
    from,
    to,
    ...(filters ? filters : {})
  });
  const [changeStatus, { isLoading: isUpdating, isSuccess: isUpdated }] = useUpdateWithdrawlMutation();

  useEffect(() => {
    if (isUpdated) {
      refetch()
      setSelectedId()
      setShowModal(false)
      setShowModal2(true)
    }
  }, [isUpdated])

  const inactiveMale = async () => {
    await changeStatus(selectedId)
  }

  useEffect(() => {
    document.title = 'Landing List | Withdrawl Requests';
  }, []);

  const onChangeFilters = (key, value) => {
    let temp = { ...filters }
    temp[key] = value
    setFilters(temp)
  }

  const FILTER_OPTIONS = [
    {
      label: "Status",
      value: filters?.active,
      setValue: (val) => onChangeFilters("status", val),
      options: [{ label: "All", value: "" }, { label: "Completed", value: "approved" }, { label: "Pending", value: "pending" }]
    }
  ]

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header
                  title="Withdrawl Requests"
                  search={search}
                  onSearch={onSearch}
                  options={FILTER_OPTIONS}
                />
                <div className="row mb-3">
                  {
                    (isLoading || isFetching) ? <Loader /> :
                      <div className="col-12">
                        <CustomTable
                          headers={maleHeaders}
                          isFilterOpen={isFilterOpen}
                          dateFilter={false}
                          filterSort={false}
                          perPage={true}
                          filterSortValues={sortValues}
                          perPageValues={perPageValues}
                          filterSortValue={sortBy}
                          setFilterSortValue={setSortBy}
                          filterFrom={from}
                          setFilterFrom={setFrom}
                          filterTo={to}
                          setFilterTo={setTo}
                          itemsPerPage={itemsPerPage}
                          setItemsPerPage={setItemsPerPage}
                          length={data?.data?.length}
                          page={page}
                          rowsPerPage={perPage}
                          onNext={onNext}
                          onPrevious={onPrevious}
                          total={data?.total}
                        >
                          <tbody>
                            {data?.data?.map((item, index) => (
                              <tr key={item._id}>
                                {/* <td><input type="checkbox" /></td> */}
                                <td>{(index + 1) + ((currentPage - 1) * itemsPerPage)}</td>
                                <td className="text-capitalize">
                                  <ProfileDisplay
                                    name={`${item?.user?.first_name} ${item?.user?.last_name}`}
                                    image={item?.user?.profile_photo}
                                  />
                                </td>
                                <td>{item?.payout?.iban_number}</td>
                                <td>{item?.payout?.bank_name}</td>
                                <td>{item?.payout?.account_name}</td>
                                <td>{item.amount} SAR</td>
                                <td>{item.reciept_no}</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <CustomButton variant={item?.status !== "approved" ? "warningButton" : "primaryButton"} text={item?.status === "approved" ? "Completed" : "Mark Completed"} className="mx-1" onClick={() => {
                                    if (item?.status !== "approved") {
                                      setSelectedId(item?._id)
                                      setShowModal(true)
                                    }
                                  }} />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </CustomTable>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <CustomModal loading={isUpdating} show={showModal} close={() => { setShowModal(false) }} action={inactiveMale} heading='Are you sure you want to mark this withdrawl as completed?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Completed' />
        </div>
      </DashboardLayout>
    </>
  );
};

export default WithdrawlRequests
